import { action, computed, makeObservable, observable } from 'mobx';
import { IPreloadingStore } from './IPreloadingStore';

export class BasePreloadingStore implements IPreloadingStore {
  protected _isPreloaded: boolean;

  public get isPreloaded() {
    return this._isPreloaded;
  }

  constructor() {
    this._isPreloaded = false;
    makeObservable<BasePreloadingStore, '_isPreloaded' | 'preloaded'>(this, {
      _isPreloaded: observable,
      isPreloaded: computed,
      preloaded: action
    });
  }

  protected preloaded() {
    this._isPreloaded = true;
  }
}
